// extracted by mini-css-extract-plugin
export default {"sideMenu":"styles_sideMenu__-1uJW"};